// @ts-ignore
import { generateClasses } from '@formkit/themes';

export const formkitConfig = {
  config: {
    classes: generateClasses({
      global: {
        outer: 'formkit-outer mt-4 mb-4',
        label: 'formkit-label block text-sm font-medium text-gray-700 mb-1 font-bold',
        help: 'formkit-help mt-2 text-sm text-gray-500',
        messages: 'formkit-messages list-none p-0 mt-1 mb-0',
        message: 'formkit-message text-red-500 mb-1 text-xs',
      },
      text: {
        outer: 'mb-4',
        label: 'block text-sm font-medium text-gray-700 mb-1 font-bold',
        inner: 'relative',
        input:
          'formkit-input block w-full bg-white rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 min-h-[38px] field-sizing-fixed',
        help: 'mt-2 text-sm text-gray-500',
        messages: 'list-none p-0 mt-1 mb-0',
        message: 'text-red-500 mb-1 text-xs',
      },
      date: {
        outer: 'mb-4',
        label: 'block text-sm font-medium text-gray-700 mb-1 font-bold',
        inner: 'relative',
        input:
          'formkit-input block w-full bg-white rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 min-h-[38px] field-sizing-fixed',
        help: 'mt-2 text-sm text-gray-500',
        messages: 'list-none p-0 mt-1 mb-0',
        message: 'text-red-500 mb-1 text-xs',
      },
      number: {
        outer: 'mb-4',
        label: 'block text-sm font-medium text-gray-700 mb-1 font-bold',
        inner: 'relative',
        input:
          'formkit-input block w-full bg-white rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 min-h-[38px] field-sizing-fixed',
        help: 'mt-2 text-sm text-gray-500',
        messages: 'list-none p-0 mt-1 mb-0',
        message: 'text-red-500 mb-1 text-xs',
      },
      select: {
        outer: 'mb-4',
        label: 'block text-sm font-medium text-gray-700 mb-1 font-bold',
        inner: 'relative',
        input:
          'formkit-input block w-full bg-white rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 min-h-[38px] field-sizing-fixed',
        help: 'mt-2 text-sm text-gray-500',
        messages: 'list-none p-0 mt-1 mb-0',
        message: 'text-red-500 mb-1 text-xs',
      },
      multiselect: {
        outer: 'mb-4',
        label: 'block text-sm font-medium text-gray-700 mb-1 font-bold',
        inner: 'relative',
        input:
          'formkit-input block w-full bg-white rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 min-h-[38px] field-sizing-fixed',
        help: 'mt-2 text-sm text-gray-500',
        messages: 'list-none p-0 mt-1 mb-0',
        message: 'text-red-500 mb-1 text-xs',
        option: 'formkit-option',
      },
      textarea: {
        outer: 'mb-4',
        label: 'block text-sm font-medium text-gray-700 mb-1 font-bold',
        inner: 'relative',
        input:
          'formkit-input block w-full min-h-[100px] bg-white rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 min-h-[38px] field-sizing-fixed',
        help: 'mt-2 text-sm text-gray-500',
        messages: 'list-none p-0 mt-1 mb-0',
        message: 'text-red-500 mb-1 text-xs',
      },
      checkbox: {
        outer: 'mb-4',
        wrapper: 'flex flex-wrap gap-2',
        input: 'formkit-input mr-2',
        label: 'text-gray-700 cursor-pointer',
        option: 'relative',
        decorator: 'hidden',
        labelDecorator: 'hidden',
        optionDecorator: 'hidden',
        optionLabel: 'cursor-pointer',
        optionLabelSelected: 'bg-indigo-100 text-indigo-700',
      },
      tel: {
        outer: 'mb-4',
        label: 'block text-sm font-medium text-gray-700 mb-1 font-bold',
        inner: 'relative',
        input:
          'formkit-input block w-full bg-white rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 min-h-[38px] field-sizing-fixed',
        help: 'mt-2 text-sm text-gray-500',
        messages: 'list-none p-0 mt-1 mb-0',
        message: 'text-red-500 mb-1 text-xs',
      },
      email: {
        outer: 'mb-4',
        label: 'block text-sm font-medium text-gray-700 mb-1 font-bold',
        inner: 'relative',
        input:
          'formkit-input block w-full bg-white rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 min-h-[38px] field-sizing-fixed',
        help: 'mt-2 text-sm text-gray-500',
        messages: 'list-none p-0 mt-1 mb-0',
        message: 'text-red-500 mb-1 text-xs',
      },
      password: {
        outer: 'mb-4',
        label: 'block text-sm font-medium text-gray-700 mb-1 font-bold',
        inner: 'relative',
        input:
          'formkit-input block w-full bg-white rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 min-h-[38px] field-sizing-fixed',
        help: 'mt-2 text-sm text-gray-500',
        messages: 'list-none p-0 mt-1 mb-0',
        message: 'text-red-500 mb-1 text-xs',
      },
      submit: {
        outer: 'mb-4',
        wrapper: 'mb-1',
        input:
          'w-full sm:w-auto justify-center inline-flex items-center border border-transparent font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 px-4 py-2 text-sm',
      },
    }),
  },
};
